<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://sayanbusiness.com" target="_blank"></a>
      <span class="ml-1">&copy; 2016-{{new Date().getFullYear()}} </span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Made by</span>
      <a href="https://sayanbusiness.com" target="_blank">Sayan Business</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
